// tamagui-ignore
import { i18n } from '@unistocks/shared/localization/i18n';
import Head from 'expo-router/head';
import { useEffect } from 'react';
import { useTheme } from 'tamagui';

export const MetaTags = () => {
  const theme = useTheme();

  useEffect(() => {
    const unsubscribe = i18n.onChange(instance => {
      document.documentElement.lang = instance.locale;
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Head key={theme.background.val}>
      <meta name="theme-color" content={theme.background.val}></meta>
    </Head>
  );
};
